import { createContext, ReactNode, useMemo } from 'react'

import {
  SanitySiteFragment,
  SanitySiteStrings,
} from '@data/sanity/queries/types/site'

const emptySiteStrings: SanitySiteStrings = {
  loadingPageTitle: '',
  languageSwitch: '',
  skipToContent: '',
  goHomeLabel: '',
  mobileMenuLabel: '',
  carouselCounterText: '',
  carouselLeftArrowLabel: '',
  carouselRightArrowLabel: '',
  carouselDotLabel: '',
  buttonAccept: '',
  buttonLearnMore: '',
  buttonTryAgain: '',
  buttonLoadMore: '',
  buttonAllFilter: '',
  emailAddress: '',
  emailAddressPlaceholder: '',
  emailMissing: '',
  emailInvalid: '',
  firstName: '',
  firstNamePlaceholder: '',
  firstNameMissing: '',
  lastName: '',
  lastNamePlaceholder: '',
  lastNameMissing: '',
  fullName: '',
  fullNamePlaceholder: '',
  fullNameMissing: '',
  phoneNumber: '',
  phoneNumberPlaceholder: '',
  phoneNumberMissing: '',
  phoneNumberInvalid: '',
  company: '',
  companyPlaceholder: '',
}

export const StringsContext = createContext<SanitySiteStrings>(emptySiteStrings)

interface StringsContextProviderProps {
  site: SanitySiteFragment
  children: ReactNode
}

export const StringsContextProvider = ({
  site,
  children,
}: StringsContextProviderProps) => {
  const strings = useMemo(
    () => ({ ...emptySiteStrings, ...site.siteStrings }),
    [site.siteStrings],
  )

  return (
    <StringsContext.Provider value={strings}>
      {children}
    </StringsContext.Provider>
  )
}
